import React from 'react';

import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px 20px;
  border-radius: 4px;
  border-top-right-radius: 0;
  position: relative;
  border: 1px solid var(--light-gray);
  border-top: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -1px;
    right: 0;
    height: 4px;
    border-radius: 4px 0 0 0;
  }

  &.pricing-analysis::before {
    background-image: linear-gradient(to left, var(--mint-green), var(--positive-green));
  }
  &.care-analysis::before {
    background-image: linear-gradient(to left, var(--lavender-purple), var(--competitor-purple));
  }
  &.fee-analysis::before {
    background-image: linear-gradient(to left, var(--warm-gold), var(--inactive-orange));
  }
  &.incentive-analysis::before {
    background-image: linear-gradient(to left, var(--orchid-pink), var(--rose-pink));
  }
`;

const IconBadge = styled.div`
  position: absolute;
  top: 0px;
  right: -1px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.pricing-analysis {
    background-image: linear-gradient(to bottom, var(--mint-green), var(--positive-green));
  }
  &.care-analysis {
    background-image: linear-gradient(to bottom, var(--lavender-purple), var(--competitor-purple));
  }
  &.fee-analysis {
    background-image: linear-gradient(to bottom, var(--light-gold), var(--inactive-orange));
  }
  &.incentive-analysis {
    background-image: linear-gradient(to bottom, var(--light-orchid), var(--rose-pink) 98%);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-bold);
  margin-bottom: 5px;
`;

const InsightList = styled.div`
  display: flex;
  flex-flow: column;
  gap: 5px;
  margin-left: -6px;
  font-size: 13px;
  color: var(--text-secondary);
`;

const InsightItem = styled.div`
  line-height: 21px;
`;

const EmptyText = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

type Props = {
  insights: string[];
  className: string;
  icon: string;
  title: string;
};

const InsightCard = ({ insights, className, icon, title }: Props) => (
  <Card className={className} data-testid={`${className}-card`}>
    <IconBadge className={className}>
      <img src={icon} alt="AI Insights icon" />
    </IconBadge>
    <CardTitle data-testid={`ai-insights-${className}-title`}>{title}</CardTitle>
    {insights.length > 0 ? (
      <InsightList data-testid={`ai-insights-${className}-text`}>
        {insights.map((insight, index) => (
          <InsightItem key={index}>· {insight}</InsightItem>
        ))}
      </InsightList>
    ) : (
      <EmptyText>No insights available</EmptyText>
    )}
  </Card>
);

export default InsightCard;
